import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

export default function PresenceToggle() {
  const [online, setOnline] = useState(null);
  const activityRef = useRef(Date.now());

  useEffect(() => {
    const init = async () => {
      try {
        const { data } = await api.get("/presence/me");
        if (data.presence !== "offline") {
          const res = await api.post("/presence", { status: "online" });
          setOnline(res.data.online);
        } else {
          setOnline(false);
        }
      } catch (e) {}
    };
    init();
    const mark = () => { activityRef.current = Date.now(); };
    window.addEventListener("click", mark);
    window.addEventListener("keydown", mark);
    window.addEventListener("mousemove", mark, { passive: true });
    const tick = setInterval(async () => {
      try {
        if (Date.now() - activityRef.current < 2 * 60 * 1000) {
          const { data } = await api.post("/presence/heartbeat");
          setOnline(data.online);
        } else {
          const { data } = await api.get("/presence/me");
          setOnline(data.online);
        }
      } catch (e) {}
    }, 60 * 1000);
    return () => {
      window.removeEventListener("click", mark);
      window.removeEventListener("keydown", mark);
      window.removeEventListener("mousemove", mark);
      clearInterval(tick);
    };
  }, []);

  const toggle = async () => {
    try {
      const { data } = await api.post("/presence", { status: online ? "offline" : "online" });
      setOnline(data.online);
    } catch (e) {}
  };

  if (online === null) return null;
  return (
    <button
      data-testid="presence-toggle"
      onClick={toggle}
      title={online ? "You are Online — click to go Offline (break)" : "You are Offline — click to go Online"}
      className="flex items-center gap-1.5 text-xs font-bold px-3 py-1 rounded-full border-2 transition-colors"
      style={online
        ? { background: "var(--cd-green)", borderColor: "var(--cd-navy)" }
        : { background: "#E2E8F0", borderColor: "var(--cd-navy)", color: "#475569" }}
    >
      <span className={`w-2 h-2 rounded-full ${online ? "bg-green-600 animate-pulse" : "bg-slate-400"}`} />
      {online ? "Online" : "Offline"}
    </button>
  );
}
